import Cookies from 'js-cookie';
import apiClient from '../middleware/apiClient';
import { ACCOUNT, COTTON_ACCOUNT, COTTON_V1_ACCOUNT } from '../helpers/apis';
import { kibanaLog } from '../helpers/logger';
import cottonFlagManager from '../helpers/featureFlags/cotton';
import { callApiWithFallback } from '../helpers/apiFallback';

// Fetch Account
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const GET_ACCOUNT_SUCCESS = 'GET_ACCOUNT_SUCCESS';
export const GET_ACCOUNT_FAILURE = 'GET_ACCOUNT_FAILURE';

export const CLEAR_ACCOUNT_CACHE = 'CLEAR_ACCOUNT_CACHE';
export const CLEAR_SWAPS_CACHE = 'CLEAR_SWAPS_CACHE';
export const CLEAR_SWAPS_ELIGIBILITY_CACHE = 'CLEAR_SWAPS_ELIGIBILITY_CACHE';

function dispatchGetAccount(endpoint = ACCOUNT) {
  return {
    type: GET_ACCOUNT,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetAccountSuccess(account) {
  return {
    type: GET_ACCOUNT_SUCCESS,
    payload: account,
  };
}

function dispatchGetAccountFailure(error) {
  return {
    type: GET_ACCOUNT_FAILURE,
    payload: error,
  };
}

export const getAccount = () => async (dispatch, getState) => {
  // TODO update to cache
  if (getState().account.cached) {
    return null;
  }
  try {
    let response;
    const { isAptV1Enabled, accountEnabled } = cottonFlagManager;

    if (isAptV1Enabled) {
      // Use APT V1 API (100% Kotlin)
      kibanaLog('apt_v1_account_api_called');
      response = await dispatch(dispatchGetAccount(COTTON_V1_ACCOUNT)).payload;
    } else if (accountEnabled) {
      // Check if SESSION cookie is missing and log to Kibana before calling Cotton API
      const sessionCookie = Cookies.get('SESSION');
      if (!sessionCookie) {
        kibanaLog('session_cookie_missing_before_calling_cotton_account_api');
      }
      // Try Cotton API, fallback to Ruby API
      response = await callApiWithFallback(
        dispatch,
        () => dispatchGetAccount(COTTON_ACCOUNT),
        () => dispatchGetAccount(ACCOUNT),
        'account',
      );
    } else {
      // Call Ruby API directly
      response = await dispatch(dispatchGetAccount(ACCOUNT)).payload;
    }
    return dispatch(dispatchGetAccountSuccess(response));
  } catch (error) {
    return dispatch(dispatchGetAccountFailure(error));
  }
};

export const clearCache = () => (dispatch) => {
  dispatch({
    type: CLEAR_ACCOUNT_CACHE,
  });
  dispatch({
    type: CLEAR_SWAPS_CACHE,
  });
  dispatch({
    type: CLEAR_SWAPS_ELIGIBILITY_CACHE,
  });
};
